// @ts-nocheck
import React, { useState } from "react";
import { Typography, Box, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isUserRole, isActiveRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";
import { SmallEyeIcon } from "../../../assets/svgs/SVGs";
import { updateNotesStatusAction } from "../../../store/actions/notifications";

const EventNotesPositionModal = ({
  open,
  onClose,
  updatedChatMetaData,
  LastActivity,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 360,
    backgroundColor: "#000",
    maxWidth: "400px",
    border: "2px solid #D175B6",
    borderRadius: "9px",
    padding: "7px 10px",
    boxShadow: "0px 0px 60px 0px #000000, 0px 0px 200px 0px #000000",
  };
  const schedule = useSelector((state) => state.contractorSchedules.schedules);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [redirectionEvents, setRedirectionEvents] = useState("");

  const handlePositionClick = (id) => {
    dispatch(updateNotesStatusAction({ status: true }));
    let matchedPosition = null;

    for (const note of updatedChatMetaData || []) {
      for (const position of note.positionIds?.positions || []) {
        if (position.id === id) {
          matchedPosition = {
            ...position,
            eventId: note.eventId,
            eventName: note.eventName,
          };
          break;
        }
      }
      if (matchedPosition) break;
    }

    if (matchedPosition) {
      setRedirectionEvents(matchedPosition);
      navigate(`/schedule`, { state: matchedPosition });
      setTimeout(() => onClose(), 0);
    }
  };

  return (
    <Box>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {updatedChatMetaData.map((note, noteIndex) => {
            const formatDateTime = (isoString) => {
              const date = new Date(isoString);
              const datePart = date.toLocaleDateString("en-US", {
                month: "long",
                day: "2-digit",
                year: "numeric",
              });
              const timePart = date.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              });
              return `${datePart} - ${timePart}`;
            };
            const formatDateOnly = (isoString) => {
              const date = new Date(isoString);
              return date.toLocaleDateString("en-US", {
                month: "long",
                day: "2-digit",
                year: "numeric",
              });
            };
            return (
              <React.Fragment key={noteIndex}>
                <Box
                  sx={{
                    width: "100%",
                    borderRadius: "5px",
                    padding: "10px",
                    background: "#FFFFFF1A",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      fontWeight="400"
                      fontSize="1.25rem"
                      sx={{
                        cursor: "pointer",
                        width: "44%",
                        margin: "auto",
                        fontWeight: 400,
                        fontSize: "1.25rem",
                        containerType: "inline-size",
                      }}
                    >
                      {note.eventName}
                    </Typography>
                    <Typography fontWeight="300" fontSize="0.75rem">
                      Last activity:
                      <span style={{ fontWeight: 500, fontSize: "0.75rem" }}>
                        {formatDateTime(note.lastActivityAt)}
                      </span>
                    </Typography>
                  </Box>
                </Box>
                {note?.positionIds?.positions?.map((position) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      marginBlock: "5px",
                    }}
                    key={position.id}
                    onClick={() => handlePositionClick(position.id)}
                  >
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                      sx={{
                        display: "flex",
                        alignItems: "center!important",
                        gap: 1,
                        cursor: "pointer",
                        width: "44%",
                        containerType: "inline-size",
                      }}
                    >
                      <SmallEyeIcon />

                      {isActiveRole(USER_ROLES.CONTRACTOR) &&
                        position?.positionName}
                    </Typography>
                    <Typography id="modal-modal-description" sx={{}}>
                      {new Date(position.date).toLocaleDateString("en-US", {
                        month: "long",
                        day: "2-digit",
                        year: "numeric",
                      })}
                    </Typography>
                  </Box>
                ))}
              </React.Fragment>
            );
          })}
        </Box>
      </Modal>
    </Box>
  );
};
export default EventNotesPositionModal;